<script>
export default {
    name: "QueueDashboard",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    }, mounted() {
      this.fetchTotalLabQueue();
      this.fetchTotalRadiologyQueue();
   
},
    methods: {
      
    
      fetchTotalLabQueue() {
      return this.$http
        .get(`Lab/GetTotalLabQueue`)
        .then((response) => {
          this.$root.pendingLabQueue = response.data;
        })
        .catch(() => {});
    }, fetchTotalRadiologyQueue() {
      return this.$http
        .get(`Radiology/GetTotalRadiologyQueue`)
        .then((response) => {
          this.$root.pendingRadiologyQueue = response.data;
        })
        .catch(() => {});
    },
  },
    components: {

      "home-tab": () => import('./Tabs/Home.vue'),
      "statistical-tab": () => import('./Tabs/Statistical.vue'),
      },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <!-- <template v-slot:card-header>
            <h5 class="font-medium text-sm">Home</h5>
        </template> -->
        <template v-slot:card-body>
            <div class="w-full flex flex-wrap">
                <ul class="w-full flex border-b mb-2">
                  <li class="-mb-px mr-1">
                    <a @click.prevent="active = 0" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active== 0 ?  activeClass : inActiveClass" 
                      href="javascript:void(0)">Home</a>
                  </li>
                  <li class="-mb-px mr-1"  v-if="$root.checkAuth('DashboardStatistics')">
                    <a @click.prevent="active = 2" 
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                      :class="active == 2 ? activeClass : inActiveClass" 
                      href="javascript:void(0)">Analytics</a>
                  </li>
                  
                </ul>
                <home-tab v-if="active === 0" />
                <statistical-tab v-if="active === 2" />
                
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
